import React from 'react'
import ReactPaginate from 'react-paginate'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { Show } from '../commons'
import styled from 'styled-components'
import _ from 'lodash'
import Select from 'react-select'
import { FormattedMessage } from 'react-intl'
import { queries } from '~/constants/mediaQuery'
import { useQueryParam, NumberParam, withDefault } from 'use-query-params'

const customStyles = {
  container: base => ({
    ...base,
    width: '100px',
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  menu: base => ({
    ...base,
    width: '100px',
  }),

  menuList: base => ({
    ...base,
    width: '100px',
  }),
}

function DropDownLimitPerPage(props) {
  return (
    <Select {...props} styles={customStyles} menuPortalTarget={document.body} />
  )
}

function Pagination({
  showLimitPerPage,
  align,
  disableRouteChange,
  onPageChange = () => {},
  onLimitChange = () => {},
  onPaginationChange = () => {},
  total = 1,
}) {
  const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 1))
  const [limit, setLimit] = useQueryParam('limit', withDefault(NumberParam, 20))
  const handlePageChange = _.debounce(({ selected: index }) => {
    onPaginationChange()
    const selectedPage = index + 1
    if (!disableRouteChange) {
      setPage(selectedPage)
    }
    onPageChange(selectedPage)
  }, 250)

  const handleLimitChange = limit => {
    onPaginationChange()
    if (!disableRouteChange && showLimitPerPage) {
      setLimit(limit)
      setPage(1)
    }
    setLimit(limit)
    onLimitChange(limit)
  }

  return (
    <Container align={align}>
      <Show condition={showLimitPerPage}>
        <div className="d-flex align-items-center">
          <DropDownLimitPerPage
            value={{ label: limit, value: limit }}
            options={[
              { label: 20, value: 20 },
              { label: 30, value: 30 },
              { label: 50, value: 50 },
              { label: 100, value: 100 },
            ]}
            className="mr-1"
            onChange={({ value }) => handleLimitChange(value)}
          />
          <FormattedMessage id="Per page" />
        </div>
      </Show>
      <ReactPaginate
        previousLabel={<ChevronLeft size="15" />}
        nextLabel={<ChevronRight size="15" />}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={Math.ceil(total / limit) || 1}
        disabledClassName="disabled"
        marginPagesDisplayed={1}
        pageRangeDisplayed={5}
        onPageChange={handlePageChange}
        forcePage={page - 1}
        containerClassName={
          'vx-pagination separated-pagination pagination-center m-1 m-sm-0'
        }
        activeClassName={'active'}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  ${({ align }) => {
    switch (align) {
      case 'center':
        return 'justify-content: center;'
      case 'between':
        return 'justify-content: space-between;'
      case 'start':
        return 'justify-content: flex-start;'
      case 'end':
        return 'justify-content: flex-end;'
      default:
        return 'justify-content: space-between;'
    }
  }}

  @media ${queries.less.xll} {
    flex-direction: column-reverse;
    align-items: center;
  }
`

export default Pagination
